module.exports = __webpack_public_path__ + "static/img/lv6.1c77f68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcImg/other/lv6.png
// module id = OkoS
// module chunks = 1